if (!customElements.get('fp-pickup-method')) {
  customElements.define('fp-pickup-method', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.connected === 'true') return;
      this.dataset.connected = 'true';
      this.choices = [...this.querySelectorAll('[data-fp-pickup-choice]')];
      this.phoneWrap = this.querySelector('[data-fp-locker-phone]');
      this.phone = this.querySelector('[data-fp-locker-phone-input]');
      this.phoneControl = this.querySelector('.fp-pickup__phone-control');
      this.phoneError = this.querySelector('[data-fp-locker-phone-error]');
      this.consent = this.querySelector('[data-fp-locker-consent]');
      this.consentWrap = this.consent?.closest('label');
      this.choices.forEach((choice) => choice.addEventListener('change', () => this.sync()));
      this.phone?.addEventListener('input', () => {
        if (this.hasCompletePhone()) this.clearPhoneError();
      });
      this.phone?.addEventListener('invalid', (event) => {
        if (!this.shouldEnforcePhone()) return;
        event.preventDefault();
        this.showPhoneError();
      });
      this.sync();
    }

    isLockerSelected() {
      return this.querySelector('[data-fp-pickup-choice="locker"]')?.checked !== false;
    }

    shouldEnforcePhone() {
      return this.dataset.fpEnforcePhone === 'true';
    }

    hasCompletePhone() {
      const digits = String(this.phone?.value || '').replace(/\D/g, '');
      return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
    }

    validateLockerPhone(options = {}) {
      if (!this.shouldEnforcePhone()) return true;
      if (this.hasCompletePhone()) {
        this.clearPhoneError();
        return true;
      }

      this.showPhoneError(options.focus !== false);
      return false;
    }

    showPhoneError(focus = true) {
      if (!this.phone) return;
      const message = 'Enter your phone number to continue.';
      this.phone.setCustomValidity(message);
      this.phone.setAttribute('aria-invalid', 'true');
      this.phoneControl?.classList.add('is-invalid');
      if (this.phoneError) {
        this.phoneError.textContent = message;
        this.phoneError.hidden = false;
      }
      if (focus) {
        this.phone.focus({ preventScroll: true });
        this.phoneWrap?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    clearPhoneError() {
      if (!this.phone) return;
      this.phone.setCustomValidity('');
      this.phone.removeAttribute('aria-invalid');
      this.phoneControl?.classList.remove('is-invalid');
      if (this.phoneError) this.phoneError.hidden = true;
    }

    sync() {
      const locker = this.isLockerSelected();
      const enforcePhone = this.shouldEnforcePhone();
      if (this.phoneWrap) this.phoneWrap.hidden = !locker && !enforcePhone;
      if (this.phone) {
        this.phone.disabled = !locker && !enforcePhone;
        this.phone.required = enforcePhone;
        this.phone.setAttribute('aria-required', enforcePhone ? 'true' : 'false');
      }
      if (this.consent) {
        this.consent.disabled = !locker;
        this.consent.required = locker;
        this.consent.setAttribute('aria-required', locker ? 'true' : 'false');
      }
      if (this.consentWrap) this.consentWrap.hidden = !locker;
      if (enforcePhone && this.hasCompletePhone()) this.clearPhoneError();
      this.dataset.method = locker ? 'locker' : 'counter';
    }
  });
}

if (!window.fpPickupPhoneValidationBound) {
  window.fpPickupPhoneValidationBound = true;

  const validateFormPickup = (form) => {
    const pickup = form?.querySelector?.('[data-fp-pickup]');
    if (!pickup || typeof pickup.validateLockerPhone !== 'function') return true;
    return pickup.validateLockerPhone({ focus: true });
  };

  document.addEventListener('click', (event) => {
    const submitter = event.target.closest?.('button[type="submit"], input[type="submit"]');
    if (!submitter?.form || validateFormPickup(submitter.form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', (event) => {
    if (validateFormPickup(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}
